export const invoiceHajjTags = [
  'InvoiceHajj',
  'NewInvoiceHajj',
  'EditInvoiceHajj',
];
export const INVOICE_HAJJ = 'InvoiceHajj';
